import React, {useState} from "react";

import cx from "classnames";

import {EventOrigin, recordEvent} from "@globals/config/eventUtils";

import DishReviewForm from "@components/DishReviewForm";
import useShowDishReviewFrom from "@components/DishReviewForm/hooks/useShowDishReviewFrom";
import {DishReviewResponse} from "@components/DishReviewForm/interfaces";
import NomiconIcon from "@components/NomiconIcon";
import TransparentButton from "@components/TransparentButton";

import styles from "./DailyDishReview.scss";

export default function DailyDishReview(): JSX.Element {
  const {orderItemForReview} = useShowDishReviewFrom();
  const [isReviewOpen, setIsReviewOpen] = useState<boolean>(true);
  const [isReminderOpen, setIsReminderOpen] = useState<boolean>(false);
  const [isReviewSubmitted, setIsReviewSubmitted] = useState<boolean>(false);
  const [dismissBtnClassName, setDismissBtnClassName] = useState<string>("");

  const handleDismiss = () => {
    if (isReviewSubmitted) {
      // user pressed "x" on success screen;
      setIsReviewOpen(false);
    } else {
      // user pressed "x" on review screen;
      setIsReminderOpen(true);
      recordEvent(EventOrigin.PAGE, "dismiss review", orderItemForReview?.id);
    }
  };

  const checkIsFullReview = (response: DishReviewResponse) => {
    if (response.review_choices.length || response.comments) {
      setIsReviewSubmitted(true);
    }
  };

  const backToReview = () => {
    setIsReminderOpen(false);
    recordEvent(EventOrigin.PAGE, "back to review", orderItemForReview?.id);
  };

  const handleReminderDismiss = () => {
    setIsReminderOpen(false);
    setIsReviewOpen(false);
  };

  if (!orderItemForReview) {
    return <></>;
  }

  return (
    <>
      {isReviewOpen && (
        // hide it with styles when reminder open to keep the state of the form;
        <div
          className={cx(
            styles.reviewContainer,
            isReminderOpen && styles.hidden
          )}
        >
          <TransparentButton
            aria-label="Close review"
            type="button"
            className={cx(styles.dismiss, dismissBtnClassName)}
            onClick={handleDismiss}
          >
            <NomiconIcon icon="nomicon-dismiss-filled" />
          </TransparentButton>
          <DishReviewForm
            orderItem={orderItemForReview}
            onSuccessReview={checkIsFullReview}
            closeRegion={() => setIsReviewOpen(false)}
            setDismissBtnClassName={setDismissBtnClassName}
          />
        </div>
      )}

      {isReminderOpen && (
        <div className={styles.reminderContainer}>
          <TransparentButton
            aria-label="Close reminder"
            type="button"
            className={cx(styles.dismiss, styles.dismissWhite)}
            onClick={handleReminderDismiss}
          >
            <NomiconIcon icon="nomicon-dismiss-filled" />
          </TransparentButton>
          <p className={styles.reminderMessage}>
            Short, simple reviews are still helpful. &nbsp;
            <TransparentButton
              className={styles.backToReview}
              onClick={backToReview}
            >
              Share your feedback with us.
            </TransparentButton>
          </p>
        </div>
      )}
    </>
  );
}
